


































import Vue from "vue";
import AppTableRow from "@/components/table/AppTableRow.vue";
import AppCheckbox from "@/components/AppCheckbox.vue";
// import AppToggleBtn from "@/components/AppToggleBtn.vue";
import { EventBus } from "@/eventbus";
export default Vue.extend({
  components: {
    AppTableRow,
    //   AppToggleBtn,
    AppCheckbox,
  },
  props: ["source"],
  setup(props) {
    const changeScan = () => {
      EventBus.emit("account-scan", props.source);
    };

    const checkChange = () => {
      EventBus.emit("account-check-change", props.source);
    };

    return {
      changeScan,
      checkChange,
    };
  },
});
